<div class="page articles">
	<div class="entrada estiloC A">
		<div class="encabezado">
			<div class="fecha">30-04-2015</div>
			<div class="titulo">Remodelación WEB apromar.org 2015</div>
			<div class="subtitulo">Adaptación a móviles y diseño responsive
				y renovado</div>
		</div>
		<div class="contenido">
			<p>En respuesta al avance de las tecnologías, que dejó obsoleto
				el funcionamiento de la web anterior, APROMAR ha renovado su web,
				adaptándola a los nuevos estándares (HTML5 + CSS + JS), así como al
				diseño responsive. No obstante, y por el momento, el sistema
				dinámico de contenido está deshabilitado hasta la total adaptación
				del funcionamiento.</p>
			<p>De esta manera, al llegar a 100% del funcionamiento,
				permanecerá conectada a las redes sociales, así como accesible desde
				dispositivos móviles y tablets. Esperamos que os guste.</p>
		</div>
	</div>
</div>